export default __webpack_public_path__ + "static/media/06_photo.e51a27f3.jpg";